import {
  axiosAccess,
  axiosROW,
  axiosFile,
  axiosApplication,
  axiosEsign,
  axiosDocument,
} from "@config/axiosConfig";
import { ApplicationDetailsPayload } from "@modules/application-section/application-details/types";
import axios from "axios";

export const getApplicationDetails = async (
  payload: ApplicationDetailsPayload,
) => {
  const { access_id } = payload;
  return await axiosAccess.get(`/access_details/${access_id}`);
};

export const getApplicationDetailsROW = async (
  payload: ApplicationDetailsPayload,
) => {
  const { access_id } = payload;
  return await axiosROW.get(`/details/${access_id}`);
};

export const getFileUploadSignedUrl = async (
  fileName: string,
  moduletype: string,
  fileSize: string,
  contentType: string,
) => {
  return await axiosFile.get(
    `/file-upload-signed-url?fileName=${fileName}&moduletype=${moduletype}&fileSize=${fileSize}&contentType=${contentType}`,
  );
};

export const uploadFileWithFormData = async (
  payload: any,
  isEsign?: boolean,
) => {
  return await axiosFile.post(
    `/upload${isEsign ? "?isEsign=true" : ""}`,
    payload,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
};

export const getPublicUrlAPI = async ({ document_name, moduletype }: any) => {
  return await axiosFile.get(
    `/public-view-license?fileName=${document_name}&moduletype=${moduletype}`,
    {
      responseType: "blob",
    },
  );
};

// export const generateEsignRequest = async (payload: any) => {
//   return await axios.post(`http://localhost:3004/backend/api/esign/generate-esign-provisional`, payload, {
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     withCredentials: true,
//   });
// };

export const generateEsignRequest = async (payload: any) => {
  return await axiosEsign.post(`/generate-esign-provisional`, payload);
};

export const getTemplateDocument = async (applicationId: number) => {
  return await axiosApplication.get(`/get-temp-file/${applicationId}`);
};

export const uploadedDocuments = async (payload: any) => {
  const { access_id, module_type, category_id } = payload;
  return await axiosDocument.get(
    `/uploaded-files/${access_id}?application_type_id=${category_id}&module_type=${module_type}`,
    {},
  );
};

//Regional Office Details
export const getRegionalOfficeDetails = async (
  payload: ApplicationDetailsPayload,
) => {
  const { access_id } = payload;
  return await axiosApplication.get(`/ro-details?applicationId=${access_id}`);
};

export const postCompleteEsignProvisional = async (payload: any) => {
  return await axiosEsign.post(`/complete-esign-provisional`, payload);
};

interface TransactionStatusPayload {
  application_id: number;
}

export const getTransactionStatus = async (
  payload: TransactionStatusPayload,
) => {
  const { application_id } = payload;
  return await axiosApplication.get(`/transaction-status/${application_id}`);
};

// receipt-details
export const getReceiptDetails = async (id: number) => {
  return await axiosApplication.get(`/receipt-details/${id}`, {});
};

// bank gaurantee-details
export const getbgDetails = async (id: number) => {
  return await axiosApplication.get(`/bank-guarantee-details/${id}`, {});
};

// PA-details
export const getpaDetails = async (id: number) => {
  return await axiosApplication.get(`/pa-details/${id}`, {});
};
